import { render, staticRenderFns } from "./SocietyMessages.vue?vue&type=template&id=f6d7dc92&scoped=true&"
import script from "./SocietyMessages.vue?vue&type=script&lang=js&"
export * from "./SocietyMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d7dc92",
  null
  
)

export default component.exports